/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:29 GMT
 */
const tokens = {
    component: {
        breadcrumbs: {
            icon: {
                color: {
                    value: "#282e37",
                    type: "color",
                },
                width: {
                    value: "24px",
                    type: "dimension",
                },
                height: {
                    value: "24px",
                    type: "dimension",
                },
            },
            link: {
                color: {
                    value: "#6f7377",
                    type: "color",
                },
                fontSize: {
                    value: "0.875rem",
                    type: "dimension",
                },
                fontWeight: {
                    value: 400,
                    type: "number",
                },
                hover: {
                    textDecoration: {
                        value: "none",
                        type: "string",
                    },
                    color: {
                        value: "#6f7377",
                        type: "color",
                    },
                },
                last: {
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                    fontWeight: {
                        value: 600,
                        type: "number",
                    },
                },
                first: {
                    fontWeight: {
                        value: 600,
                        type: "number",
                    },
                },
            },
        },
    },
};
export default tokens;
